import { render, staticRenderFns } from "./vehicleChallan.vue?vue&type=template&id=6b9710e7"
import script from "./vehicleChallan.vue?vue&type=script&lang=js"
export * from "./vehicleChallan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports